const basicFieldOptions = [
	{
		"id": null,
		"type": 'firstName',
		"required": false,
		"label": 'Name',
		"placeholder": 'Type here...',
		"displayLabel": "First Name",
		"icon": "badge",
		"customId": 'firstName',
	},
	{
		"id": null,
		"type": 'lastName',
		"required": false,
		"label": 'Surname',
		"placeholder": 'Type here...',
		"displayLabel": "Last Name",
		"icon": "badge",
		"customId": 'lastName',
	},
	{
		"id": null,
		"type": 'email',
		"required": true,
		"label": 'Email',
		"placeholder": 'Type here...',
		"displayLabel": "Email",
		"icon": "alternate_email",
		"unique": true,
		"customId": 'email',
	},
	{
		"id": null,
		"type": 'text',
		"required": false,
		"label": 'Text Field',
		"placeholder": 'Type here...',
		"displayLabel": "Text",
		"icon": "text_fields",
		"customId": 'text',
	},
	{
		"id": null,
		"type": 'checkbox',
		"required": false,
		"label": 'I agree',
		"displayLabel": "Checkbox",
		"icon": "check_box",
		"html": "Do you agree to the terms of use?",
		"customId": 'checkbox',
	},
	{
		"id": null,
		"type": 'choice',
		"required": false,
		"label": 'Yes or No?',
		"displayLabel": "Radio",
		"icon": "radio_button_checked",
		"appearance": 'radio',
		"max": 1,
		"options": ['Option 1', 'Option 2'],
		"customId": 'radioChoice',
	},
	{
		"id": null,
		"type": 'choice',
		"required": false,
		"label": 'Pick from the dropdown',
		"displayLabel": "Dropdown",
		"icon": "keyboard_arrow_down",
		"appearance": 'dropdown',
		"max": 1,
		"options": ['Option 1', 'Option 2'],
		"customId": 'dropdownChoice',
	},
	{
		"id": null,
		"type": 'date',
		"required": false,
		"label": 'Date',
		"displayLabel": "Date",
		"icon": "event_available",
		"customId": null,
	},
	{
		"id": null,
		"type": 'tel',
		"required": false,
		"label": 'Phone Number',
		"displayLabel": "Phone",
		"icon": "dialpad",
		"strictMode": true,
		"defaultCountry": null,
		"customId": 'phone',
	},
	{
		"id": null,
		"type": 'signature',
		"required": false,
		"label": 'Signature',
		"displayLabel": "Signature",
		"icon": "gesture",
		"customId": 'signature',
	},
	{
		"id": null,
		"type": 'ssn',
		"required": false,
		"label": 'Social Security Number',
		"displayLabel": "Social Security Number",
		"icon": "pin",
		"allowedLengths": [10, 12],
		"customId": 'ssn',
	}
];
const businessFieldOptions = [
	{
		"id": null,
		"type": 'text',
		"required": false,
		"label": 'Zip Code',
		"placeholder": 'Type here...',
		"displayLabel": "Zip Code",
		"icon": "blur_circular",
		"customId": 'zipCode',
	},
	{
		"id": null,
		"type": 'text',
		"required": false,
		"label": 'Street Name',
		"placeholder": 'Type here...',
		"displayLabel": "Street Name",
		"icon": "blur_circular",
		"customId": 'streetName',
	},
	{
		"id": null,
		"type": 'text',
		"required": false,
		"label": 'Street Number',
		"placeholder": 'Type here...',
		"displayLabel": "Street Number",
		"icon": "blur_circular",
		"customId": 'streetNumber',
	},
	{
		"id": null,
		"type": 'choice',
		"required": false,
		"label": 'Gender',
		"placeholder": 'Type here...',
		"displayLabel": "Gender",
		"icon": "blur_circular",
		"appearance": 'dropdown',
		"max": 1,
		"options": ['Male', 'Female'],
		"customId": 'gender',
	},
	{
		"id": null,
		"type": 'date',
		"required": false,
		"label": 'Date of birth',
		"displayLabel": "Date of birth",
		"icon": "blur_circular",
		"customId": 'dob',
	},
	{
		"id": null,
		"type": 'checkbox',
		"required": false,
		"label": 'GDPR Consent',
		"displayLabel": "GDPR Consent",
		"icon": "blur_circular",
		"customId": 'gdprConsent',
		"html": "Lorem ipsum dolor sit amet."
	},
	{
		"id": null,
		"type": 'checkbox',
		"required": false,
		"label": 'Marketing Consent',
		"displayLabel": "Marketing Consent",
		"icon": "blur_circular",
		"customId": 'marketingConsent',
		"html": "Lorem ipsum dolor sit amet."
	},
	{
		"id": null,
		"type": 'text',
		"required": false,
		"label": 'City',
		"placeholder": 'Type here...',
		"displayLabel": "City",
		"icon": "blur_circular",
		"customId": 'city',
	},
	{
		"id": null,
		"type": 'choice',
		"required": false,
		"label": 'Country',
		"displayLabel": "Country",
		"icon": "blur_circular",
		"customId": 'country',
		"appearance": 'dropdown',
		"max": 1,
		"options": ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia','Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin','Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi','Cabo Verde', 'Cambodia', 'Cameroon', 'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia','Comoros', 'Congo', 'Costa Rica', 'Cote d\'Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Democratic Republic of the Congo','Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea','Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece','Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia','Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, North','Korea, South', 'Kosovo', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein','Lithuania', 'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania','Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar','Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Macedonia', 'Norway','Oman', 'Pakistan', 'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland','Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines','Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore','Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname','Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago','Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States of America','Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe']
	},
];
export {
	basicFieldOptions,
	businessFieldOptions
}